<script>
</script>
<template>
  <div>
    <PageAllow controller="StockOuts" action="batchSortingOut" />
    <Breadcrumbs :items="items" />

    <v-sheet class="transparent-background-color">
      <v-row dense class="mx-5">
        <v-col cols="12" sm="12" md="4">
          <v-row dense align="center" class="pa-1">
            <SearcherDatetimeRangeWithRadio
                    v-model="options"
                    type="datetime"
                    show-radios
                    :radios="datetimeRadios"
                    deleteIcon
                    removeIcon
            />
          </v-row>
        </v-col>
        <v-col cols="12" sm="12" md="8" align-self="center">
          <v-row dense align="center" class="search-controls">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  text
                  class="px-0 py-0 caption font-weight-bold grey--text"
                  color="primary"
                  @click.stop="onSearch()"
                >
                  <v-icon small class="pe-1">fa-search</v-icon>
                  {{ $t("Search.search") }}
                </v-btn>
              </template>
              <span>{{ $t("Search.searchTip") }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  text
                  class="caption font-weight-bold grey--text"
                  @click.stop="resetSearch()"
                >
                  <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                  {{ $t("Search.reset") }}
                </v-btn>
              </template>
              <span>{{ $t("Search.resetTip") }}</span>
            </v-tooltip>
            <v-divider vertical />
            <v-btn
              class="caption font-weight-bold grey--text"
              :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
              small
              text
              @click.stop="$store.commit('toggleSearchPanel')"
            >
              {{ $t("Search.pro") }}
              <v-icon small class="ps-1">{{
                $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
              }}</v-icon>
            </v-btn>

            <v-col>
              <!-- 下一步按钮 -->
              <v-btn
                      v-if="
                  settings &&
                  !settings.stock_position_setting
                "
                      small
                      color="primary"
                      class="ms-1 float-end"
                      :disabled="stockSelected?false:true"
                      @click.stop="
                        nextDialog = true;"
              >
                {{ $t("StockOrderOUT.PickingOut.next") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-expansion-panels
        v-model="$store.getters.panels"
        multiple
        flat
        accordion
      >
        <v-expansion-panel class="transparent-background-color">
          <v-expansion-panel-content>
            <v-row dense align="center">
              <!-- 仓库 -->
              <v-col cols="12" sm="6" md="4">
                <v-autocomplete
                        color="primary"
                        hide-no-data
                        v-model="stockSelected"
                        :clearable="true"
                        :items="stocksItems"
                        :loading="stockLoading"
                        :search-input.sync="stockSearch"
                        item-text="Description"
                        item-value="id"
                        item-disabled="disabled"
                        :label="$t('Stock.ObjectName')"
                        return-object
                ></v-autocomplete>
              </v-col>
              <!-- 商品分类 -->
              <v-col cols="12" sm="6" md="4">
                <SearcherMaterialCategoriesWithDescendants v-model="materialCategoriesSelected" />
              </v-col>
              <!-- 商品 -->
              <v-col cols="12" sm="6" md="4">
                <SearcherMaterials v-model="materialSelected" />
              </v-col>
              <!-- 客户 -->
              <v-col cols="12" sm="6" md="4">
                <SearcherShops v-model="shopsSelected" />
              </v-col>
              <!-- 分组 -->
              <v-col cols="12" sm="6" md="4">
                <SearcherDistrictsWithDescendants
                        v-model="districtsSelected"
                        :label="$t('Shop.shopDistrict', [$consts.shopName()])"
                />
              </v-col>
              <!-- 配送路线 -->
              <v-col cols="12" sm="6" md="4">
                <SearcherDistributionUser
                  v-model="distributionUserSelected"
                  :stockId="stockSelected ? stockSelected.id : 0"
                />
              </v-col>
              <!-- 配送点 -->
              <v-col cols="12" sm="6" md="4" v-if="settings && settings.delivery_point && $permission.permissionAllow('DeliveryPoints', 'index')">
                <SearcherDeliveryPoint v-model="deliveryPointSelected" />
              </v-col>
              <!-- 分拣状态 -->
              <v-col cols="12" sm="6" md="4">
                <SearcherStatus
                        v-model="options.sorting_status"
                        :label="$t('StockOrderOUT.PickingOut.status')"
                        :items="$consts.stock_out_order.sorting_status"
                />
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <div class="mx-4 mb-4">
        <v-data-table
          :headers="headers"
          :items="stock_outs"
          :options.sync="options"
          :page.sync="paging.page"
          :server-items-length="paging.count"
          :loading="loading"
          multi-sort
          class="elevation-2 px-4 pt-1 sticky-table"
          id="sticky-table"
          :class="stickTableCols ? 'sticky-first-col sticky-last-col' : ''"
          fixed-header
          :footer-props="$t('$config.footer-props')"
        >
          <template v-slot:header.actions="{ header }">
            {{ header.text }}
            <v-icon x-small>fa-sliders-h</v-icon>
          </template>

          <template v-slot:item.stock_order_code="{ item, index }">
            <span
              class="text-no-wrap caption font-weight-bold"
              :v-resize="!index ? $stickTableResizer() : null"
            >
              {{ item.stock_order_code }}
            </span>
            <br />
            <span
              class="text-no-wrap caption secondary--text"
              :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
            >
              {{ item.created | formatTime }}
            </span>
          </template>
          <template v-slot:item.details_count="{ item }">
            {{ (item.sorting_details_count) ? item.sorting_details_count: 0 }} / {{item.details_count}}
          </template>
          <template v-slot:item.sorting_status="{ item }">
            <v-chip
              small
              label
              :color="item.sorting_status | stockOrderSortingStatusColor"
              :text-color="item.sorting_status | stockOrderSortingStatusTextColor"
            >
              {{ item.sorting_status | stockOrderSortingStatusText }}
            </v-chip>
            <br />
            <v-chip
              v-if="item.cancel_flg"
              x-small
              label
              outlined
              color="danger"
            >
              {{ $t("CRUD.cancelled") }}
            </v-chip>
          </template>
        </v-data-table>
      </div>
    </v-sheet>

    <!-- 批量分拣出库 -->
    <DialogPickingOut
            v-model="nextDialog"
            :search="options"
            :searchData="searchData"
            @confirm="
              nextDialog = false;
              confirmDialog = true;
              confirmData=$event"
            @pickingOut="
              nextDialog=false;
              $router.push('/' + oldPath);"
    />
    <!-- 批量分拣出库 -->
    <DialogConfirm
            v-model="confirmDialog"
            :options="options"
            :confirmData="confirmData"
            @back="
              nextDialog = true;
              confirmDialog = false;"
            @confirm="
              confirmDialog = false;
              $router.push('/' + oldPath);"
    />
  </div>
</template>

<script>
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import { mapState } from "vuex";
import StockOuts from "@/api/stock_outs";
import SearcherDatetimeRangeWithRadio from "@/components/plugins/SearcherDatetimeRangeWithRadio";
import SearcherStatus from "@/components/plugins/SearcherStatus";
import SearcherDistrictsWithDescendants from "@/components/plugins/SearcherDistrictsWithDescendants";
import SearcherDistributionUser from "@/components/plugins/SearcherDistributionUser";
import SearcherDeliveryPoint from "@/components/plugins/SearcherDeliveryPoint";
import SearcherShops from "@/components/plugins/SearcherShops";
import SearcherMaterials from "@/components/plugins/SearcherMaterials";
import SearcherMaterialCategoriesWithDescendants from "@/components/plugins/SearcherMaterialCategoriesWithDescendants";
import DialogPickingOut from "./plugins/DialogPickingOut";
import DialogConfirm from "./plugins/DialogConfirm";
import Stocks from "@/api/stocks";


const defaultOptions = {
  datetimeRadioSelected: "created",
  created_time_from:
    new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
      .toISOString()
      .substr(0, 10) + " 00:00:00",
  created_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",
  actual_time_from: "",
  actual_time_to: "",
  expect_time_from: "",
  expect_time_to: "",
  stock_ids: null,
  category_codes: [],
  material_ids: [],
  shop_ids: [],
  district_ids: [],
  distribution_user_id: [],
  sorting_status: [],
  type: 1,
  status: [2],
  cancel_flgs: [0],
  real_stock_flg: 1,
  delivery_point_id: null,
};

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    SearcherDatetimeRangeWithRadio,
    SearcherStatus,
    SearcherDistrictsWithDescendants,
    SearcherDistributionUser,
    SearcherDeliveryPoint,
    SearcherShops,
    SearcherMaterials,
    SearcherMaterialCategoriesWithDescendants,
    DialogPickingOut,
    DialogConfirm,
  },
  computed: {
    items() {
      return [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.stockManagement"),
          disabled: false,
          replace: true,
          href:"/stocks",
        },
        {
          text:i18n.t("Nav.stockOrdersOut"),
          disabled: false,
          href: "/stock-orders-out",
        },
        {
          text:i18n.t("StockOrderOUT.PickingOut.title"),
          disabled: true,
        },
      ];
    },
    headers() {
      return [
        {
          text:
            i18n.t("StockOrderOUT.Fields.stock_out_code") +
            " / " +
            i18n.t("StockOrderOUT.Fields.created_time"),
          align: "start",
          sortable: false,
          value: "stock_order_code",
        },
        {
          text: i18n.t("StockOrderOUT.Fields.stock_out_obj_name"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "obj_name",
        },
        {
          text: i18n.t("StockOrderOUT.Fields.stock_name"),
          align: "start",
          sortable: false,
          value: "stock.name",
        },
        {
          text:  i18n.t("StockOrderOUT.Fields.picked_count") +
                  " / " +
                  i18n.t("StockOrderOUT.Fields.detail_count"),
          align: "center",
          class: "text-no-wrap",
          sortable: false,
          value: "details_count",
        },
        {
          text: i18n.t("StockOrderOUT.Fields.status"),
          align: "start",
          sortable: false,
          value: "sorting_status",
        },
      ];
    },
    datetimeRadios() {
      return [
        {
          key: "created",
          text: i18n.t("StockOrderOUT.Fields.created_time"),
        },
        {
          key: "actual",
          text: i18n.t("StockOrderOUT.Fields.actual_time"),
        },
        {
          key: "expect",
          text: i18n.t("StockOrderOUT.Fields.expect_time"),
        }
      ]
    },
    stocksItems() {
      var stocks;
      if (this.stockDistrict) {
        stocks = this.stocks.filter(
                (stock) => stock.stock_district_code == this.stockDistrict.code
        );
      } else {
        stocks = this.stocks;
      }
      if (this.stockDistricts && this.stockDistricts.length > 0) {
        stocks = this.stocks.filter((e) =>
                this.stockDistricts.find((v) => v.code == e.stock_district_code)
        );
      } else {
        stocks = this.stocks;
      }
      return stocks.map((stock) => {
        const Description = stock.code + " / " + stock.name;
        const disabled = this.disabledItems
                ? this.disabledItems.find(
                        (disabledItem) => disabledItem.id == stock.id
                )
                : false;
        return Object.assign({}, stock, { Description, disabled });
      });
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings", "stickTableCols"]),
  },

  data: () => ({
    options: JSON.parse(
            sessionStorage.getItem("stock-orders-picking-out-options")
                    ? sessionStorage.getItem("stock-orders-picking-out-options")
                    : JSON.stringify(defaultOptions)
    ),
    stock_outs: [],
    paging: {},
    stockSelected: null,
    stocks: [],
    stockLoading: false,
    stockSearch: "",
    materialCategoriesSelected: [],
    materialSelected: [],
    shopsSelected: [],
    districtsSelected: [],
    distributionUserSelected: null,
    deliveryPointSelected: null,
    nextDialog: false,
    confirmDialog: false,
    confirmData: {},
    searchData: [],
    oldPath: "",
  }),

  methods: {
    resetSearch() {
      this.stockSelected = null;
      this.materialCategoriesSelected = [];
      this.materialSelected = [];
      this.shopsSelected = [];
      this.districtsSelected = [];
      this.distributionUserSelected = null;
      this.deliveryPointSelected = null;
      //重置options
      this.options = JSON.parse(JSON.stringify(defaultOptions));
      //重置搜索框
      let clearArr = [this.$refs.stock_order_code];
      clearArr.push(this.$refs.ext_code);
      clearArr.forEach((k) => {
        if (k) k.clear();
      });
    },
    onSearch() {
      this.options = Object.assign({}, this.options, {
      });
    },
    getStockOutsFromAPI() {
      if ( this.options.datetimeRadioSelected && this.options.datetimeRadioSelected == 'actual') {
        this.options.actual_date_from = this.options.actual_time_from
        this.options.actual_date_to = this.options.actual_time_to
      }
      if ( this.options.datetimeRadioSelected && this.options.datetimeRadioSelected == 'expect') {
        this.options.expect_date_from = this.options.expect_time_from
        this.options.expect_date_to = this.options.expect_time_to
      }
      this.options.real_stock_flg = 1
      StockOuts.fetch(this.options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.stock_outs = response.data.stock_outs;
            this.paging = response.data.paging;
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
        }.bind(this)
      );
    },
    getSelectedSession() {
      this.$commonUtils.loadOptions("stock-orders-picking-out", [
              "stockSelected",
              "materialCategoriesSelected",
              "materialSelected",
              "shopsSelected",
              "districtsSelected",
              "distributionUserSelected",
              "deliveryPointSelected",
      ]).then(
              function (data) {
                if (data.options) {
                  this.options = data.options;
                  if (
                          typeof this.options.created_time_from != "undefined" &&
                          typeof this.options.created_time_to != "undefined"
                  )
                    this.datetimeRage = [
                      this.options.created_time_from,
                      this.options.created_time_to,
                    ];
                } else this.resetSearch();

                data.selecteds.forEach((selected) => {
                  switch (selected.key) {
                    case "stockSelected":
                      this.stockSelected = selected.value;
                      break;
                    case "materialSelected":
                      this.materialSelected = selected.value;
                      break;
                    case "materialCategoriesSelected":
                      this.materialCategoriesSelected = selected.value;
                      break;
                    case "shopsSelected":
                      this.shopsSelected = selected.value;
                      break;
                    case "districtsSelected":
                      this.districtsSelected = selected.value;
                      break;
                    case "distributionUserSelected":
                      this.distributionUserSelected = selected.value;
                      break;
                    case "deliveryPointSelected":
                      this.deliveryPointSelected = selected.value;
                      break;
                  }
                });
              }.bind(this)
      );
    },
    getOldSearch() {
      let oldSearch = JSON.parse(sessionStorage.getItem("picking-out-old-search")
              ? sessionStorage.getItem("picking-out-old-search")
              : {}
      )
      this.stockSelected = oldSearch.stock_id;
      this.materialCategoriesSelected = oldSearch.category_codes;
      this.materialSelected = oldSearch.material_ids;
      this.shopsSelected = oldSearch.shop_ids;
      this.districtsSelected = oldSearch.district_ids;
      this.oldPath = oldSearch.old_path
      sessionStorage.setItem(
              "stock-orders-picking-out-stockSelected",
              JSON.stringify(this.stockSelected)
      );
      sessionStorage.setItem(
              "stock-orders-picking-out-materialCategoriesSelected",
              JSON.stringify(this.materialCategoriesSelected)
      );
      sessionStorage.setItem(
              "stock-orders-picking-out-materialSelected",
              JSON.stringify(this.materialSelected)
      );
      sessionStorage.setItem(
              "stock-orders-picking-out-shopsSelected",
              JSON.stringify(this.shopsSelected)
      );
      sessionStorage.setItem(
              "stock-orders-picking-out-districtsSelected",
              JSON.stringify(this.districtsSelected)
      );
    },
    getStockList() {
      Stocks.fetchAllForSelect({ types: [0], status: 1 })
              .then(
                      function (response) {
                        if (response.data.status.isOK()) {
                          this.stocks = response.data.stocks;
                          let idList = this.stocks.map((detail) => {
                            return detail.id
                          })
                          if (!idList.includes(this.options.stock_ids)) {
                           this.stockSelected = null
                          }
                        }
                        this.stockLoading = false;
                      }.bind(this)
              )
              .catch(
                      function () {
                        this.stockLoading = false;
                      }.bind(this)
              );
    }
  },

  mounted() {
    this.getStockList();
    this.getOldSearch()
    this.getSelectedSession()
  },

  watch: {
    $route() {
      //   if (!this.$route.query.stock_id) {
      //     this.currentItemMode = null;
      //     this.currentItem = null;
      //   }
    },
    options: {
      // immediate: true, //为避免覆盖session里保存的options，不能启用immediate
      deep: true,
      handler() {
        this.getStockOutsFromAPI();
        sessionStorage.setItem("stock-orders-picking-out-options", JSON.stringify(this.options));
      },
    },
    // 仓库
    stockSelected: {
      handler() {
        this.options.stock_ids = this.stockSelected
                ? this.stockSelected.id
                : "";
        this.searchData.stockName = this.stockSelected
                ? this.stockSelected.Description
                : "";
        sessionStorage.setItem(
                "stock-orders-picking-out-stockSelected",
                JSON.stringify(this.stockSelected)
        );
      },
    },
    // 商品分类
    materialCategoriesSelected: {
      handler() {
        this.options.category_codes = this.materialCategoriesSelected
                ? this.materialCategoriesSelected.map((e) => {
                  return e.code;
                })
                : "";
        sessionStorage.setItem(
                "stock-orders-picking-out-materialCategoriesSelected",
                JSON.stringify(this.materialCategoriesSelected)
        );
      },
    },
    // 商品
    materialSelected: {
      handler() {
        this.options.material_ids = this.materialSelected
          ? this.materialSelected.map((e) => {
              return e.id;
            })
          : "";
        sessionStorage.setItem(
          "stock-orders-picking-out-materialSelected",
          JSON.stringify(this.materialSelected)
        );
      },
    },
    // 客户选择
    shopsSelected: {
      handler() {
        this.options.shop_ids = this.shopsSelected
                ? this.shopsSelected.map((alliance) => {
                  return alliance.id;
                })
                : "";
        sessionStorage.setItem(
                "stock-orders-picking-out-shopsSelected",
                JSON.stringify(this.shopsSelected)
        );
      },
    },
    // 分组查询
    districtsSelected: {
      handler() {
        this.options.district_ids = this.districtsSelected
                ? this.districtsSelected.map((e) => {
                  return e.id;
                })
                : "";
        sessionStorage.setItem(
                "stock-orders-picking-out-districtsSelected",
                JSON.stringify(this.districtsSelected)
        );
      },
    },
    // 配送路线
    distributionUserSelected: {
      handler() {
          this.options.distribution_user_id = this.distributionUserSelected
            ? this.distributionUserSelected.id
            : null;
        this.searchData.distribution = this.distributionUserSelected
                ? this.distributionUserSelected.name
                : null;
          sessionStorage.setItem(
            "stock-orders-picking-out-distributionUserSelected",
            JSON.stringify(this.distributionUserSelected)
          );
      },
    },
    deliveryPointSelected: {
      handler() {
        this.options.delivery_point_id = this.deliveryPointSelected
          ? this.deliveryPointSelected.id
          : null;
        sessionStorage.setItem(
          "stock-orders-picking-out-deliveryPointSelected",
          JSON.stringify(this.deliveryPointSelected)
        )
      }
    },
    confirmDialog: {
      handler() {
        if (this.nextDialog == false && this.confirmDialog == false) {
          this.getStockOutsFromAPI()
        }
      }
    },
    nextDialog: {
      handler() {
        if (this.nextDialog == false && this.confirmDialog == false) {
          this.getStockOutsFromAPI()
        }
      }
    }
  },
};
</script>